import { keys, reject } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

/**
 * create request params from form data of hierarchy "login, sellerIn, firstName - surname" and remove
 * empty values
 *
 * @param formData
 * @returns {{userHierarchy: string}}
 */
export const createRequestQueryParamsFromFormData = (formData) => {
	const resolveObject = {};
	const dataKeys = keys(formData);

	for (const key of dataKeys) {
		const value = formData[key];
		if (!isNilOrEmpty(value)) {
			resolveObject[key] = value;
		}
	}

	return resolveObject;
};

export const removeNulls = reject((val) => isNilOrEmpty(val));
